import { render, staticRenderFns } from "./AddressLookupComponent.vue?vue&type=template&id=6437b43a&scoped=true&"
import script from "./AddressLookupComponent.vue?vue&type=script&lang=js&"
export * from "./AddressLookupComponent.vue?vue&type=script&lang=js&"
import style0 from "./AddressLookupComponent.vue?vue&type=style&index=0&id=6437b43a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6437b43a",
  null
  
)

export default component.exports